<template>
  <v-alert
    color="primario"
    outlined
    dense
    class="novidades-content-help mb-4"
    icon="fas fa-info-circle"
  >
    <p class="mb-2 font-weight-medium">Formato do conteúdo no portal</p>
    <p class="mb-2">
      Cada melhoria vira um card no portal. Use um bloco por item: emoji
      opcional, título curto terminando em <strong>:</strong> (exibido em negrito
      no portal) e descrição na mesma linha ou nas seguintes. Não use
      asteriscos (<code>**</code>); para ênfase no texto use
      <code>&lt;strong&gt;…&lt;/strong&gt;</code>. Linha em branco entre itens.
    </p>
    <p class="mb-2">
      Links markdown viram botões no detalhe:
      <code>[Acessar Artigo](url)</code> ou <code>[Clique Aqui](url)</code>.
    </p>
    <p class="mb-2">
      <strong>Palavras-chave</strong> (campo acima) aparecem como filtros
      <code>#tag</code> no portal — cadastre sem o caractere <code>#</code>.
    </p>
    <p class="mb-2">
      <strong>Ícone</strong> da novidade: classe Font Awesome (<code
        >fas fa-lock</code
      >) ou nome lógico do portal (Sparkles, Zap, Tag, Shield, Package…).
    </p>

    <p class="mb-1 text-caption">Exemplo mínimo (copiar):</p>
    <pre class="novidades-content-help__pre">{{ minimalExample }}</pre>
    <v-btn small outlined color="primary" class="mb-3" @click="copyMinimal">
      <v-icon left small>far fa-copy</v-icon>
      Copiar exemplo
    </v-btn>

    <v-expansion-panels flat class="novidades-content-help__panels">
      <v-expansion-panel>
        <v-expansion-panel-header class="px-0 py-1">
          Ver exemplo com várias melhorias
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <pre class="novidades-content-help__pre">{{ shortExample }}</pre>
          <v-btn small text color="primary" @click="copyShort">
            Copiar exemplo completo
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <p class="mb-0 mt-2 text-caption">
      Referência interna: discovery
      <em>novidades-portal-refatoracao-2026</em> (repositório docs).
    </p>
  </v-alert>
</template>

<script>
import {
  NOVIDADES_CONTENT_MINIMAL_EXAMPLE,
  NOVIDADES_CONTENT_SHORT_EXAMPLE
} from "@/utils/novidades/novidades-content-examples";

export default {
  name: "NovidadesContentHelp",
  data: () => ({
    minimalExample: NOVIDADES_CONTENT_MINIMAL_EXAMPLE,
    shortExample: NOVIDADES_CONTENT_SHORT_EXAMPLE
  }),
  methods: {
    copyText(text, successMessage) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$vueOnToast.pop("success", successMessage);
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Não foi possível copiar.");
          });
        return;
      }
      this.$vueOnToast.pop("error", "Copiar não disponível neste navegador.");
    },
    copyMinimal() {
      this.copyText(this.minimalExample, "Exemplo copiado.");
    },
    copyShort() {
      this.copyText(this.shortExample, "Exemplo completo copiado.");
    }
  }
};
</script>

<style scoped>
.novidades-content-help {
  font-size: 13px;
  line-height: 1.5;
  border-radius: 14px !important;
  border-left-width: 5px !important;
  border-left-style: solid !important;
  border-left-color: var(--primary-color, #1976d2) !important;
}
.novidades-content-help ::v-deep .v-alert__wrapper {
  align-items: flex-start;
}
.novidades-content-help ::v-deep .v-alert__icon {
  align-self: flex-start;
  margin-top: 2px;
}
.novidades-content-help__pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.04);
  padding: 8px 10px;
  border-radius: 8px;
  margin: 0 0 8px;
}
.novidades-content-help__panels {
  background: transparent;
}
</style>
